/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Collapse: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M17.3691 9.22462C17.7619 8.90427 18.3409 8.92686 18.707 9.29298L23.707 14.293L22.293 15.707L18 11.4141L13.707 15.707L12.293 14.293L17.293 9.29298L17.3691 9.22462Z'
      fill='currentColor'
    />
  </React.Fragment>
)
